import React, { useEffect, useState } from 'react';
import PayEMI from './Pay_EMI';
import {
  convertUTCToIST,
  formatToIndianRupees,
  insertCommas,
  fetchpaymentstatus,
  setActivity,
  getdata
} from '../../Global/Index';
import Cookies from 'js-cookie';
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@mui/material';

const override = {
  display: "block",
  margin: "10% auto",
  marginLeft: '50%'
};

export default function PayOnline() {
  const [emi, setEmi] = useState(0);
  const [paymentStatusResponse, setPaymentStatusResponse] = useState(null);
  const [loanAccountNumber, setLoanAccountNumber] = useState(null);
  const [oppertunityId, setOppertunityId] = useState(null);
  const theme = useTheme();
  const [showAll, setShowAll] = useState(false);


  // Format current date
  const getCurrentDate = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Handling error responses
  const handleErrorResponse = (status, message = '') => {
    switch (status) {
      case '500':
        toast.error('Something went wrong. Please try again later!');
        break;
      case '503':
        toast.warn(message || 'Service temporarily unavailable');
        break;
      case '419':
      case '401':
        window.location.href = '/Session-Expired';
        break;
      default:
        toast.error('An unexpected error occurred');
    }
  };

  // Initial data fetch
  useEffect(() => {
    const fetchInitialData = async () => {
      const token = Cookies.get('token');
      if (!token) {
        window.location.href = '/';
        return;
      }

      try {
        setActivity('Pay Online Page');
        const response = await getdata();

        if (response.response.status === '200') {
          setOppertunityId(response.response.data.OpportunityId)
          setLoanAccountNumber(response.response.data.LoanAccountNumber);
          const responsepaymentstatus = await fetchpaymentstatus(response.response.data.LoanAccountNumber);
          if (responsepaymentstatus.response.status === '200') {
            setPaymentStatusResponse(responsepaymentstatus.response.data);
          } else {
            handleErrorResponse(responsepaymentstatus.response.status, responsepaymentstatus.response.message);
          }
        } else {
          handleErrorResponse(response.response.status, response.response.message);
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        toast.error('Failed to load initial data');
      }
    };

    fetchInitialData();
  }, []);


  if (!loanAccountNumber) {
    return (
      <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
        <ToastContainer />
        <h2>Pay Online</h2>
        <div className="mainsubcontainer">
          <p style={{ textAlign: 'center', maginTop: '2vh' }}>Unable to load loan information. Please try again later.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
        <h2>Pay Online</h2>
        <div className="mainsubcontainer">
          {loanAccountNumber && oppertunityId ? (
            <>
              <div className="paymentpara">
                <b>
                  {`Details of payment dues ( Rs. ${insertCommas(emi)}/- ) for this Account No. ${loanAccountNumber}`}
                </b>
              </div>

              <div className='amountpayable'>
                <b>{`TOTAL AMOUNT PAYABLE : ${formatToIndianRupees(emi)}/-`}</b>
              </div>



              {paymentStatusResponse?.length > 0 && (
                <div>
                  {paymentStatusResponse
                    .slice(0, showAll ? paymentStatusResponse.length : 1)
                    .map((item, index) => (
                      <div
                        key={index + 1}
                        style={{
                          margin: '10px',
                          padding: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '5px',
                          backgroundColor: '#90ee907a'
                        }}
                      >
                        <p>
                          You have successfully paid for amount <b>{item.amount}</b> on{' '}
                          <b>{convertUTCToIST(item.date_time)}</b>. Please keep Transaction id{' '}
                          <b>{item.txnID}</b> for reference. If amount is not reflected it will be
                          reflected within <b>1 day</b>
                        </p>
                      </div>
                    ))}

                  {paymentStatusResponse.length > 1 && (
                    <button
                      onClick={() => setShowAll(!showAll)}
                      style={{
                        margin: '10px',
                        padding: '8px 16px',
                        backgroundColor: 'mediumseagreen',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      {showAll ? 'Show Less' : `Show More ( ${paymentStatusResponse.length - 1} more )`}
                    </button>
                  )}
                </div>
              )}

              <PayEMI setEmi={setEmi} />
            </>
          ) : (
            <ClipLoader
              color={theme.palette.maincolor.light}
              loading={true}
              cssOverride={override}
              size={30}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          )}
        </div>
      </div>
    </>
  );
}